///////////////////////////////////////////////////

import { referentialApiConnector } from 'apiConnector/secondary-market/referentialApiConnector';
import { DominoError } from 'apiConnector/secondary-market/reports';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { secondaryMarketCpOrderSettlementTypeFetchedThunk } from 'state/secondaryMarket/cpOrder/cpOrderForm/cpOrderForm.thunks';
import { secondaryMarketCpOrderSettlementTypesFailed } from 'state/secondaryMarket/cpOrder/referential/client/client.actions';
import type { EpicWithThunk } from 'state/state.common';
import { HttpError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function fetchSettlementTypesEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getSettlementTypes } = referentialApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_SETTLEMENT_TYPES_FETCH_REQUESTED'),
      mergeMap(({ bcsProductKey, clientBdrId, custodianBdrId, tabId }) => {
        return getSettlementTypes(bcsProductKey, clientBdrId, custodianBdrId).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => secondaryMarketCpOrderSettlementTypeFetchedThunk(tabId, data)),
          catchError((err: HttpError<DominoError>) => {
            return of(secondaryMarketCpOrderSettlementTypesFailed(tabId, err.payload?.message));
          }),
        );
      }),
    );
  };
}
